import { ArrowLeft, CheckCircle, Clock, Shield, Zap, TrendingUp } from 'lucide-react';

export default function Guncel2025Page() {

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-950 via-red-900 to-orange-900">
      {/* Header */}
      <div className="bg-white/10 backdrop-blur-xl border-b border-white/20">
        <div className="container mx-auto px-4 py-6">
          <button
            onClick={() => window.location.href = '/'}
            className="flex items-center gap-2 text-white hover:text-orange-300 transition-all"
          >
            <ArrowLeft className="w-5 h-5" />
            Ana Sayfaya Dön
          </button>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16">
        <div className="max-w-5xl mx-auto">
          {/* Hero */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-3 bg-gradient-to-r from-red-600 to-orange-600 text-white px-8 py-4 rounded-full font-bold text-xl mb-6 shadow-2xl animate-pulse">
              <Clock className="w-8 h-8 animate-spin-slow" />
              <span>SÜREKLI GÜNCEL İÇERİK</span>
            </div>
            <h1 className="text-7xl font-black text-white mb-6">
              Her Şey <span className="text-orange-400">Güncel</span> ve Hazır!
            </h1>
            <p className="text-2xl text-white/90 leading-relaxed max-w-3xl mx-auto">
              İsveç trafik mevzuatındaki <strong className="text-orange-400">tüm güncellemeler</strong> sorularımıza hemen yansıtılıyor. 
              Sınava girecekseniz, doğru yerdesiniz!
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid md:grid-cols-2 gap-8 mb-16">
            <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-8">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-600 rounded-2xl flex items-center justify-center mb-4">
                <Shield className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-3xl font-black text-white mb-4">Yeni Kurallar Eklendi</h3>
              <p className="text-white/80 text-lg leading-relaxed">
                En son değişen <strong>hız limitleri</strong>, <strong>yeni trafik işaretleri</strong> ve 
                <strong> güncel sınav formatı</strong> tam olarak sorularımıza yansıtıldı.
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-8">
              <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-600 rounded-2xl flex items-center justify-center mb-4">
                <TrendingUp className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-3xl font-black text-white mb-4">Eskimiş Sorular Temizlendi</h3>
              <p className="text-white/80 text-lg leading-relaxed">
                Artık geçerli olmayan eski sorular <strong>tamamen kaldırıldı</strong>. 
                Sadece Trafikverket sınavında çıkan güncel sorular var!
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-8">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-2xl flex items-center justify-center mb-4">
                <Zap className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-3xl font-black text-white mb-4">Her Hafta Güncelleme</h3>
              <p className="text-white/80 text-lg leading-relaxed">
                Trafikverket'in yaptığı değişiklikleri <strong>anında takip ediyoruz</strong>. 
                İçeriğimiz her zaman en güncel haliyle sizinle!
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-8">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-600 rounded-2xl flex items-center justify-center mb-4">
                <CheckCircle className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-3xl font-black text-white mb-4">Garantili Uyumluluk</h3>
              <p className="text-white/80 text-lg leading-relaxed">
                Tüm sorularımız <strong>Trafikverket standartlarına %100 uyumlu</strong>. 
                Sınavda sürprizle karşılaşmazsınız!
              </p>
            </div>
          </div>

          {/* CTA */}
          <div className="bg-gradient-to-r from-orange-600 to-red-600 rounded-3xl p-12 text-center shadow-2xl">
            <h2 className="text-5xl font-black text-white mb-6">
              Güncel Sorularla Pratik Yapmaya Başla! 🎯
            </h2>
            <p className="text-2xl text-white/90 mb-8 leading-relaxed">
              Premium üyelikle <strong>2,500+ soruya</strong> sınırsız erişim!
            </p>
            <button
              onClick={() => {
                // Ana sayfaya git ve login modal'ı aç
                window.location.href = '/?action=login';
              }}
              className="bg-white text-red-600 px-12 py-6 rounded-2xl font-black text-2xl hover:scale-110 transition-all shadow-2xl"
            >
              💎 Premium'a Geç - Hemen Başla!
            </button>
            <p className="text-white/80 mt-6 text-lg">
              ✅ Ücretsiz deneme • ✅ Anında başlangıç • ✅ Mobil uyumlu
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
